import { entityActionWrapper } from 'barnyard/utils';
import * as types from '~/accounts/merchants/constants';

const vendorWithMetadata = entityActionWrapper({
  UPDATE_ACTION: types.VENDOR_UPDATE,
  GET_ACTION: types.VENDOR_FETCH
});

const vendor = (state = {}, action) => {
  switch (action.type) {
    case types.VENDOR_UPDATE.request:
    case types.VENDOR_UPDATE.success:
    case types.VENDOR_UPDATE.failure:
    case types.VENDOR_FETCH.request:
    case types.VENDOR_FETCH.success:
    case types.VENDOR_FETCH.failure:
      return vendorWithMetadata(state, action, action.result);
    default:
      return state;
  }
};

export {
  vendor
};
